var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-img',{staticClass:"img-paypal",attrs:{"src":"/images/paypal.png","alt":_vm.$t('altTag',{
                    affiliate:_vm.$root.affiliate
                  })}}),_vm._m(0)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap-btn-payment"},[_c('div',{attrs:{"id":"paypal-button"}}),_c('br')])}]

export { render, staticRenderFns }